import { Observable } from 'rxjs/Observable';
import setEventBranchDeepLink from '../actions/events/setEventDeepLinkAction';

export function handleCreateEventDeepLinkFulfilled(action$, store) {
   return action$.filter(
      action => action.type === 'CREATE_EVENT_DEEP_LINK_FULFILLED')
      .mergeMap((action) => Observable.merge(
         Observable.of(setEventBranchDeepLink(store.getState().events.currentEvent.objectId, action.payload))));
}



// WEBPACK FOOTER //
// ./src/epics/createEventDeepLinkEpic.js